import requests from './httpService';

const SchooleRegistrationService = {
  getAllSchooleRegistration() {
    return requests.get('/registration');
  },

  // Create school (master or branch)
  creteSchooleRegistration(body) {
    return requests.post('/registration/add', body);
  },

  // Upload school logo
  uploadImage(body) {
    return requests.post('/registration/uploadimage', body);
  },

  // OTP generation (if used)
  otpGerate(body) {
    return requests.post('/registration/otp', body);
  },

  // Get master school and all its branch schools for a given admin user
  getSchoolsForAdmin(userId) {
    return requests.get(`/registration/admin/${userId}/schools`);
  },

  // Get single school by id
  getSchoolById(id) {
    return requests.get(`/registration/${id}`);
  },

  // Get master + branch schools with student / attendance / activity counts
  getSchoolsWithStatsForAdmin(userId) {
    return requests.get(`/registration/admin/${userId}/schools-with-stats`);
  },

  // Get branch schools by parentSchoolId (for table display)
  getBranchesByParent(parentSchoolId) {
    return requests.get(`/registration/branches/${parentSchoolId}`);
  },
};

export default SchooleRegistrationService;

